<template>
  <div class="text-center mt-8 mx-4">
    <div v-if="isSuccess">
      <div class="mb-8">
        <v-icon
            color="green"
            size="90"
        >
          mdi-checkbox-marked-circle-outline
        </v-icon>
      </div>
      <h5 class="text-h5 mb-8">Оплата прошла успешно</h5>

      <div class="text-subtitle-1 mb-8">
        <p>
          Вы успешно оплатили заказ <b>№ {{orderNumber}}</b> на сумму <b>{{amount | number}} ₽</b>
        </p>
        <p v-if="paymentDescribe">
          {{paymentDescribe}}
        </p>
      </div>
    </div>
    <div v-else>
      <div class="mb-8">
        <v-icon
            color="red"
            size="90"
        >
          mdi-close-circle-outline
        </v-icon>
      </div>
      <h5 class="text-h5 mb-8">При оплате возникла ошибка</h5>

      <p class="text-subtitle-1 mb-8">
        {{errorMessage}}
      </p>
    </div>

    <div
      v-if="isFrame && !hideButton"
      class="align-center"
    >
      <v-btn
        color="primary"
        @click="close"
      > {{isSuccess ? 'Перейти к покупкам' : 'Попробовать еще раз'}}</v-btn>
    </div>
    <p
      v-else
      class="primary--text"
    >
      Для продолжения работы закройте эту страницу
    </p>
  </div>
</template>

<script>

export default {
  name: 'AcquiringPaymentResult',
  computed: {
    paymentDescribe: function () {
      const arr = []
      if (this.fromAcquiring) {
        arr.push(`оплачено по карте: ${this.$root.$options.filters['number'](this.fromAcquiring, 2)} ₽`)
      }
      if (this.fromBalance) {
        arr.push(`оплачено с баланса: ${this.$root.$options.filters['number'](this.fromBalance, 2)} ₽`)
      }
      const res = arr.join(', ')
      return res ? res.charAt(0).toUpperCase() + res.slice(1) : ''
    }
  },
  created () {
    this.amount = this.$route.query.amount
    this.errorMessage = this.$route.query.errorMessage
    this.fromAcquiring = +this.$route.query.fromAcquiring
    this.fromBalance = +this.$route.query.fromBalance
    this.hideButton = this.$route.query.hideButton === 'true'
    this.isFrame = window.self !== window.top
    this.orderNumber = this.$route.query.orderNumber
    this.sourceId = this.$route.query.sourceId
    this.status = this.$route.query.status
    this.isSuccess = this.status === 'success'
  },
  data () {
    return {
      amount: null,
      errorMessage: null,
      fromAcquiring: null,
      fromBalance: null,
      hideButton: false,
      isFrame: false,
      isSuccess: false,
      orderNumber: null,
      sourceId: null,
      status: null
    }
  },
  methods: {
    close () {
      window.parent.postMessage({
        'msg': {
          type: 'close',
          result: this.status
        }
      }, '*')
    }
  }
}
</script>

<style scoped>

</style>
